import type { Rv } from '~/types/api'

export default (rv: Rv) => {
  const config = useRuntimeConfig()
  const searchAddress = `${rv.location?.city},${rv.location?.regionCode},${rv.location?.countryCode}`
  const type = rv.class
  return `${config.public.app.rentals.webUrl}/rv-search?SearchAddress=${searchAddress}&types=${
    type === 'TravelTrailer' ? `Sub${type}` : type
  }`
}
